var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.$style.switcher},[_c('input',_vm._g({attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked,"value":_vm.value}},_vm.$listeners)),_vm._v(" "),_c('span',{class:_vm.$style.switch})])
}
var staticRenderFns = []

export { render, staticRenderFns }